import ValidationError from "../validationError";
import PaymentStep from "../../../formability/form_builder/models/workflow/paymentStep";
import {ErrorType} from "~/enums/ErrorType";
import {PaymentType} from "../../enums/workflow/paymentType";
import NavigableValidator from "~/models/navigableValidators/navigableValidator";

export default class PaymentStepValidator extends NavigableValidator<PaymentStep> {
  _validatorKey = 'payment_step';
  defaultMessage = 'must be valid';
  defaultType = ErrorType.invalidValue;

  hasGateway(model) {
    return !!model.payment_gateway_id;
  }

  hasValidProductionGateway(model) {
    return model.is_production_payment_gateway_valid;
  }

  hasLineItems(model) {
    return Object.keys(model.payment_line_items).length > 0;
  }

  hasOnlinePayment(model: PaymentStep): boolean {
    return model.payment_type === PaymentType.onlinePayment || model.payment_type === PaymentType.onlinePaymentOrCheck;
  }


  _validate(model: PaymentStep): void {
    // default payment type is online payment
    if (this.hasOnlinePayment(model)) {
      if (!this.hasGateway(model)) {
        this.errors.push(this.buildValidationError(model, 'A payment gateway must be present', ErrorType.mustBePresent));
      } else if (!this.hasValidProductionGateway(model)) {
        this.errors.push(this.buildValidationError(model, 'A payment gateway with a live environment must be present.', ErrorType.mustBePresent));
      }
    }
    if (!this.hasLineItems(model)) {
      this.errors.push(this.buildValidationError(model, 'A Payment Line Item must be present', ErrorType.mustBePresent));
    }
  }

  buildValidationError(model: PaymentStep, value?, type?) {
    return new ValidationError({
      message: value || this.options.message || this.defaultMessage,
      displayName: `${model.titleOrDefault} (step)`,
      errorNavOpts: model.validation.errorNavOpts(this, 'payment_step', model),
      type: type || this.defaultType,
      section: this.section
    });
  }

}